import React from 'react';
import logo from '../../logo_colored_transp_no_text.png';

const NexusCoin = ({ size = 24, style = {} }) => {
  const depth = 8; // Érme vastagsága
  const thickness = 4; // Összesített vastagság pixelben

  return (
    <div style={{
      width: size,
      height: size,
      position: 'relative',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      perspective: '1000px',
      ...style
    }}>
      <style>{`
        @keyframes nexus-coin-spin {
          from { transform: rotateY(0deg); }
          to { transform: rotateY(360deg); }
        }
        .nexus-coin-container {
          width: 100%;
          height: 100%;
          position: relative;
          transform-style: preserve-3d;
          animation: nexus-coin-spin 4s linear infinite;
        }
        .coin-face {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          backface-visibility: hidden;
          display: flex;
          alignItems: center;
          justify-content: center;
          border-radius: 50%;
        }
        .coin-back {
          transform: rotateY(180deg) translateZ(3px);
        }
        .coin-front {
          transform: translateZ(3px);
        }
        .coin-edge {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          border-radius: 50%;
          background: #DAA520;
          border: 0.5px solid #8B4513;
          backface-visibility: visible;
        }
      `}</style>

      <div className="nexus-coin-container">
        {/* --- ÉRME ÉLE (VASTAGSÁG) --- */}
        {[...Array(depth)].map((_, i) => (
          <div
            key={i}
            className="coin-edge"
            style={{ transform: `translateZ(${(i - depth / 2) * 0.6}px)` }}
          />
        ))}

        {/* --- HÁTOLDAL (KÖRIRATTAL) --- */}
        <div className="coin-face coin-back">
          <svg viewBox="0 0 100 100" style={{ width: '100%', height: '100%' }}>
            <circle cx="50" cy="50" r="48" fill="#FDB931" stroke="#8B4513" strokeWidth="1" />
            <circle cx="50" cy="50" r="40" fill="none" stroke="#8B4513" strokeWidth="0.5" strokeDasharray="2 2" opacity="0.3" />

            {/* Körirat útvonala */}
            <defs>
              <path id="circlePath" d="M 50, 50 m -35, 0 a 35,35 0 1,1 70,0 a 35,35 0 1,1 -70,0" />
            </defs>

            <text fill="#8B4513" fontSize="10" fontWeight="900" letterSpacing="2">
              <textPath xlinkHref="#circlePath" startOffset="0%">
                NEXUS KREDIT • NEXUS KREDIT •
              </textPath>
            </text>

            {/* Központi díszítő elem a hátoldalon */}
            <circle cx="50" cy="50" r="15" fill="#DAA520" stroke="#8B4513" strokeWidth="1" />
            <text x="50" y="55" textAnchor="middle" fill="#8B4513" fontSize="14" fontWeight="bold">NX</text>
          </svg>
        </div>

        {/* --- ELŐOLDAL (LOGÓVAL) --- */}
        <div className="coin-face coin-front">
          <svg viewBox="0 0 100 100" style={{ position: 'absolute', width: '100%', height: '100%' }}>
            <defs>
              <linearGradient id="coinGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" stopColor="#FFD700" />
                <stop offset="50%" stopColor="#FDB931" />
                <stop offset="100%" stopColor="#B8860B" />
              </linearGradient>
              <linearGradient id="rimGradient" x1="0%" y1="0%" x2="0%" y2="100%">
                <stop offset="0%" stopColor="#FFFACD" />
                <stop offset="100%" stopColor="#8B4513" />
              </linearGradient>
            </defs>
            <circle cx="50" cy="50" r="48" fill="url(#coinGradient)" stroke="#8B4513" strokeWidth="1" />
            <circle cx="50" cy="50" r="42" fill="none" stroke="url(#rimGradient)" strokeWidth="2" opacity="0.4" />
            <circle cx="50" cy="50" r="35" fill="white" opacity="0.9" />
          </svg>
          <img
            src={logo}
            alt="Nexus"
            style={{
              width: '80%',
              height: '80%',
              zIndex: 10,
              position: 'relative',
              top: '12%',
              left: '3%',
              objectFit: 'contain',
              filter: 'drop-shadow(0px 1px 2px rgba(0,0,0,0.2))'
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default NexusCoin;
